import type { ReactNode } from 'react';

export const symbol_folder_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m434-396-64-64q-9-9-21-9t-21 9.05q-9 9.06-9 21.5 0 12.45 9 21.45l84 84q9.07 9 21.53 9 12.47 0 21.47-9l170-170q9-8.8 9-20.9 0-12.1-9.05-21.1-9.06-9-21.5-9-12.45 0-21.45 9L434-396ZM140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h256q12.44 0 23.72 5t19.37 13.09L481-740h339q23 0 41.5 18.5T880-680v460q0 23-18.5 41.5T820-160H140Zm0-60h680v-460H456l-60-60H140v520Zm0 0v-520 520Z"
		/>
	</svg>
);
